module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-10 col-md-11 box-label",
    class: {
      'border-color-skin': _vm.choiceDisp
    },
    attrs: {
      "name": "item-desc"
    },
    on: {
      "click": function($event) {
        _vm.toggleChoiceDisp()
      }
    }
  }, [_c('div', {
    staticClass: "main-label",
    class: {
      'active color-skin': _vm.choiceDisp
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.choice.grade) + ": " + _vm._s(_vm.choice.desc_grditem) + " " + _vm._s(_vm.choice.descgrd) + "  (" + _vm._s(_vm.choice.qtyscor) + " คะแนน)")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choiceDisp),
      expression: "choiceDisp"
    }],
    staticClass: "more-label"
  }, [_vm._v(_vm._s(_vm.choice.definit))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7bac506a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres7de/itemDesc.vue
// module id = 3914
// module chunks = 1